import { defineMessages } from 'react-intl';

export default defineMessages({
    overdueRepaymentTitle: {
        id: '_.overdue_payments.overdue_repayment_title',
        defaultMessage: 'Get back on track'
    },
    overdueRepayment: {
        id: '_.overdue_payments.overdue_repayment',
        defaultMessage:
            "Time to get back on track: you're overdue by {overduePaymentAmount}. Having trouble? {link}"
    },
    overdueRepaymentLink: {
        id: '_.overdue_payments.overdue_repayment_link',
        defaultMessage: 'We can help'
    },
    overdueRepaymentCTA: {
        id: '_.overdue_payments.overdue_repayment_cta',
        defaultMessage: 'Repay overdue amount'
    }
});
